/* [D-700/701] «🔬 Чому схожість висока»: що змінювало кадр (✓), що ні (✗), шматки, що збіглися, і варіанти «що зробить зеленим» з ефектом за
   нашими замірами (API /api/users/{id}/similarity, лише токен власника). Спільне для сторінки юзера й картки учня партнера в дашборді OWNER. */
import React from 'react';
import { Box, Typography } from '@mui/material';

export const simCol = (v) => (v >= 50 ? '#ff6b6b' : v >= 20 ? '#ffb74d' : '#4caf50');

export default function SimWhy({ sims }) {
  const vs = Object.keys(sims || {}).map(Number).sort((a, b) => a - b);
  const top = vs.map(v => sims[v]).filter(s => s && s.why).sort((a, b) => b.same_pct - a.same_pct)[0];
  if (!top) return null;
  const w = top.why;
  return (
    <Box data-simwhy="1" sx={{ mb: 1, p: 1, borderRadius: 1, border: '1px solid rgba(255,107,107,.45)', bgcolor: 'rgba(255,107,107,.06)' }}>
      <Typography variant="caption" sx={{ color: '#ff6b6b', fontWeight: 'bold', display: 'block', mb: 0.4 }}>
        🔬 Чому схожість висока ({w.app}){w.head ? ': ' + w.head : ''}
      </Typography>
      {w.yes.map((t, i) => <Typography key={'y' + i} variant="caption" sx={{ color: '#4caf50', display: 'block' }}>✓ {t}</Typography>)}
      {w.no.map((t, i) => <Typography key={'n' + i} variant="caption" sx={{ color: '#ffb0a8', display: 'block' }}>✗ {t}</Typography>)}
      {vs.map(v => sims[v] && sims[v].why && sims[v].why.ranges && sims[v].why.ranges.length ? (
        <Typography key={'r' + v} variant="caption" sx={{ color: '#cfc8cc', display: 'block' }}>
          v{v} {Math.round(sims[v].same_pct)}% - збіглися з оригіналом: {sims[v].why.ranges.join(', ')}{sims[v].why.sec ? ' (заміряно перші ' + Math.round(sims[v].why.sec) + ' с)' : ''}
        </Typography>) : null)}
      {w.fix && !(w.tips && w.tips.length && !top.strong) ? <Typography variant="caption" sx={{ color: '#f5c84c', display: 'block', mt: 0.4, fontWeight: 'bold' }}>{w.fix}</Typography> : null}
      {w.tips && w.tips.length ? (
        <Box sx={{ mt: 0.6 }}>
          <Typography variant="caption" sx={{ color: '#f5c84c', display: 'block', fontWeight: 'bold' }}>
            Що зробить зеленим{w.base ? ' (' + w.base + ')' : ''}:
          </Typography>
          {w.tips.map((t, i) => (
            <Typography key={'t' + i} data-simtip={i + 1} variant="caption" sx={{ color: '#f5e6b8', display: 'block', pl: 1 }}>
              • {t.t}{t.e ? <span style={{ color: '#4caf50' }}> - {t.e}</span> : null}{t.a ? <span style={{ color: '#ff6b6b', fontWeight: 'bold' }}> · ⚠ {t.a}</span> : null}
            </Typography>
          ))}
        </Box>) : null}
    </Box>
  );
}

/* [D-701] замовлення юзера з рядків заміру: група за order_salt, версії, найбільша схожість, пояснення найгіршої */
export function simOrders(rows, limit) {
  const by = {};
  (rows || []).forEach(r => { if (Number(r.order_salt) < 0) return; const k = String(r.order_salt); (by[k] = by[k] || { at: r.created_at, sims: {} });
    if (!by[k].sims[r.ver] || r.id > by[k].sims[r.ver].id) by[k].sims[r.ver] = r; if (r.created_at > by[k].at) by[k].at = r.created_at; });
  return Object.values(by).sort((a, b) => (a.at < b.at ? 1 : -1)).slice(0, limit || 10)
    .map(o => ({ ...o, max: Math.max(...Object.values(o.sims).map(s => s.same_pct)) }));
}
